
import { motion } from "framer-motion";

export const EnglishFinancialSystem = () => {
  return (
    <div className="bg-blue-50 p-6 rounded-lg mb-8">
      <h2 className="text-xl font-semibold mb-4 text-blue-800">How Loans Work in Finland</h2>
      <p className="mb-4">
        Finland has a stable and secure banking system with competitive interest rates. All loan applications require a Finnish personal ID (henkilötunnus) and typically check your credit information through the Suomen Asiakastieto registry.
      </p>
      <p className="mb-4">
        Most loans in Finland require:
      </p>
      <ul className="list-disc pl-5 mb-4 space-y-2">
        <li>Regular income and good credit history</li>
        <li>Finnish citizenship or permanent residency</li>
        <li>Age of at least 18 years (some loans require 20+ years)</li>
        <li>No payment defaults or credit blocks</li>
      </ul>
      <p>
        With Lainasampo.fi, you can complete one application and receive multiple loan offers from different Finnish banks and financial institutions, saving you time and potentially securing better interest rates.
      </p>
    </div>
  );
};
